import { useState, useEffect } from "react";

export const useIntersectionObserver = (
  ref,
  options = {},
  triggerOnce = false
) => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting);

      if (triggerOnce && entry.isIntersecting && ref.current) {
        observer.unobserve(ref.current);
      }
    }, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref, options, triggerOnce]);

  return isIntersecting;
};
